<template>
    <div>
        <div class="form-group">
            <label for="send-via-email-select2">Contacts</label>
            <select2 :has-children="true" :multiple="true" id="send-via-email-select2" :options="contacts" :select-options="{ placeholder: 'Select Contacts' }" v-model="selectedContacts"></select2>
        </div>

        <div class="form-group">
            <label for="send-via-email-content">Content</label>
            <textarea class="form-control" v-model="content" id="send-via-email-content"></textarea>
        </div>

        <div class="form-group">
            <label for="send-via-email-datepicker">Expiry Date</label>
            <input class="form-control" type="text" id="send-via-email-datepicker" v-model="selectedDate">
        </div>

        <a class="btn btn-secondary" @click="sendViaEmail">Send</a>
    </div>
</template>

<script>
    import Select2 from "../../Generic/Select2";
    export default {
        name: "SendViaEmail",
        components: {Select2},
        data(){
            return {
                contacts: {},
                selectedContacts: [],
                content: '',
                selectedDate: moment().add('1', 'M').format('DD/MM/YYYY')
            }
        },

        mounted(){

            let self = this;

            axios.get('/api/contacts/all').then(function(response){
                self.contacts = response.data.contacts;
            });

            $('#send-via-email-datepicker').datetimepicker({
                format: 'DD/MM/YYYY',
                inline: true,
                minDate: 'now'
            }).on('dp.change', function(e){
                self.selectedDate = e.date.format('DD/MM/YYYY');
            });
        },

        methods: {
            sendViaEmail(){
                let self = this;
                axios.post('/api/documents/file/email', {
                    contacts: this.selectedContacts,
                    expiry_date: this.selectedDate,
                    files: Object.keys(this.$store.state.selectedFiles),
                    content: this.content,
                    type: this.$store.state.job_type,
                    id: this.$store.state.job_id
                }).then(function(response){
                    toastr.success(response.data.message);
                    self.$parent.closeModal();
                });
            },
        }
    }
</script>
